"use strict";
'use es6';

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.addEngagementToTimeline = addEngagementToTimeline;
exports.addEngagementToTimelineById = addEngagementToTimelineById;
exports.createEngagement = createEngagement;
exports.processEngagement = processEngagement;
exports.updateOwnerAssociations = updateOwnerAssociations;
exports.updateAssociations = updateAssociations;
exports.updateEngagementFieldsAndAssociations = updateEngagementFieldsAndAssociations;
exports.handleAssociationLimitError = void 0;

var _ = require("_");

var _immutable = require("immutable");

var _loggers = require("customer-data-tracking/loggers");

var _AttachmentsActions = _interopRequireDefault(require("crm_ui/attachments/data/AttachmentsActions"));

var _TimelineActions = _interopRequireDefault(require("crm_ui/timeline/data/actions/TimelineActions"));

var EngagementsActions = _interopRequireWildcard(require("crm_data/engagements/EngagementsActions"));

var _ownerUpdates = _interopRequireDefault(require("crm_ui/utils/ownerUpdates"));

var _Alerts = require("customer-data-ui-utilities/alerts/Alerts");

var QueuesActionsMediator = _interopRequireWildcard(require("crm_ui/queues/QueuesActionsMediator"));

var _UpdateAssociationsHelper = require("crm_ui/engagementAssociations/utils/UpdateAssociationsHelper");

var _EngagementTypes = _interopRequireDefault(require("customer-data-objects/engagement/EngagementTypes"));

var _EngagementsAPI = require("crm_data/engagements/api/EngagementsAPI");

var _ExceededEngagementAssociationLimitAlert = require("./ExceededEngagementAssociationLimitAlert");

var NONEXISTENT_ACTIVITY_TYPE = 'NONEXISTENT_ACTIVITY_TYPE';
var HIT_FROM_OBJECT_LIMIT = 'HIT_FROM_OBJECT_LIMIT';

var logEngagementCreated = function logEngagementCreated(engagementRecord) {
  var type = engagementRecord.engagement.get('type');
  var schedule = '';

  if (engagementRecord.metadata.has('title')) {
    // verb for context clarification
    schedule = 'schedule';
  }

  _loggers.CrmLogger.log('recordUsage', {
    action: 'create engagement',
    type: (schedule + " " + type.toLowerCase()).trim()
  });

  _loggers.CrmLogger.log('createEngagementActivation', {
    type: type.toLowerCase()
  });

  if (_EngagementTypes.default.TASK === type) {
    var manuallyCreated = !!engagementRecord.metadata.get('status');

    _loggers.CrmLogger.log('createTask', {
      action: 'task created',
      // we only set the status when tasks are created manually
      // in the communicator
      createMethod: manuallyCreated ? 'manual' : 'automatic',
      createSource: manuallyCreated ? 'communicator' : undefined
    });
  }
};

var logAttachmentsOnEngagement = function logAttachmentsOnEngagement(engagementRecord) {
  var attachments = engagementRecord.attachments;

  if (attachments.size > 0) {
    _loggers.CrmLogger.log('recordUsage', {
      action: 'add engagement'
    });
  }

  return engagementRecord;
};

var logAtMentions = function logAtMentions(engagementRecord) {
  var ownerIds = engagementRecord.associations.get('ownerIds');

  if (ownerIds && ownerIds.size > 0) {
    var type = engagementRecord.engagement.get('type');
    var location = "Interaction Pane - " + type;

    _loggers.CrmLogger.log('recordUsage', {
      action: 'use @mention',
      location: location
    });
  }

  return engagementRecord;
};

var addAttachments = function addAttachments(engagementRecord, attachments) {
  _AttachmentsActions.default.addAttachments(attachments);

  return engagementRecord;
};

var addToQueue = function addToQueue(interactionRecord) {
  var extraData = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : (0, _immutable.Map)();
  var engagementRecord = arguments.length > 2 ? arguments[2] : undefined;
  var queues = extraData.get('queues');

  if (!queues) {
    return engagementRecord;
  }

  var queueId = interactionRecord.get('queueId');

  if (!queueId) {
    return engagementRecord;
  }

  var queue = queues.get(queueId);
  var selected = [engagementRecord.getIn(['engagement', 'id'])];
  QueuesActionsMediator.addToQueue(queue, selected);
  return engagementRecord;
};

var handleEngagementCreated = function handleEngagementCreated(engagementRecord, extraData, _ref) {
  var createdEngagementRecord = _ref.createdEngagementRecord,
      associationCreateFailures = _ref.associationCreateFailures;
  if (associationCreateFailures.length > 0) (0, _ExceededEngagementAssociationLimitAlert.displayAssociationFailureNotification)(createdEngagementRecord, associationCreateFailures, extraData); // Preserve teamId, which is not returned in the create API response
  // (team association is async). Optimistically assume that the created
  // engagement will eventually belong to the current team

  var teamId = engagementRecord.getIn(['engagement', 'teamId']);
  return teamId ? createdEngagementRecord.setIn(['engagement', 'teamId'], teamId) : createdEngagementRecord;
};

var handleActivityTypeError = function handleActivityTypeError(error, type) {
  var activityType = '';

  if (error.responseJSON.errorTokens) {
    activityType = error.responseJSON.errorTokens.activityType[0];
  }

  (0, _Alerts.addDanger)('contactInteraction.errors.NONEXISTENT_ACTIVITY_TYPE', {
    type: type,
    activityType: activityType
  });
};

var handleAssociationLimitError = function handleAssociationLimitError(error, type, subjectId) {
  error.validationResults.forEach(function (validationResult) {
    if (validationResult.result === HIT_FROM_OBJECT_LIMIT) {
      var message = 'contactInteraction.errors.HIT_FROM_OBJECT_LIMIT';
      var objectType = validationResult.row.fromObjectType.toLowerCase();
      var limit = validationResult.row.definition.maxToObjectIds;
      var associationSubjectId = validationResult.row.fromObjectId;

      if (associationSubjectId === subjectId) {
        message = 'contactInteraction.errors.associationLimitExceeded';
      }

      (0, _Alerts.addDanger)(message, {
        type: type,
        objectType: objectType,
        limit: limit
      });
    }
  });
};

exports.handleAssociationLimitError = handleAssociationLimitError;

var handleError = function handleError(engagementRecord, subjectId, error) {
  var type = engagementRecord.engagement.get('type').toLowerCase();
  var responseJSON = error.responseJSON;

  if (responseJSON && responseJSON.errorType === NONEXISTENT_ACTIVITY_TYPE) {
    handleActivityTypeError(error, type);
  } else if (responseJSON && responseJSON.status === 'error') {
    handleAssociationLimitError(responseJSON, type, subjectId);
  } else {
    (0, _Alerts.addDanger)('contactInteraction.errors.save', {
      type: type
    });
  }

  throw new Error(error);
};

function addEngagementToTimeline(engagementRecord) {
  var timestamp = engagementRecord.engagement.get('timestamp');
  var createdAt = engagementRecord.engagement.get('createdAt');
  var timelineEvent = (0, _immutable.fromJS)({
    eventData: engagementRecord,
    etype: 'eventEngagement',
    timestamp: timestamp,
    id: "eventEngagement-" + createdAt + "-0"
  });

  _TimelineActions.default.addEngagement(timelineEvent);

  return engagementRecord;
}

function addEngagementToTimelineById(engagementId) {
  (0, _EngagementsAPI.batchFetch)([engagementId]).then(function (engagementRecords) {
    addEngagementToTimeline(engagementRecords.get("" + engagementId));
  });
}

var performEngagementProcessing = (0, _.compose)(addEngagementToTimeline, logAtMentions, function (engagementRecord) {
  return addAttachments(engagementRecord, engagementRecord.attachments);
}, logAttachmentsOnEngagement);

function createEngagement(engagementRecord, objectType, interactionRecord) {
  var extraData = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : (0, _immutable.Map)();
  logEngagementCreated(engagementRecord, objectType);
  return EngagementsActions.createEngagement(engagementRecord).then((0, _.partial)(handleEngagementCreated, engagementRecord, extraData), (0, _.partial)(handleError, engagementRecord, extraData.get('subjectId'))).then((0, _.partial)(addToQueue, interactionRecord, extraData), (0, _.partial)(handleError, engagementRecord, extraData.get('subjectId'))).then(function (engagement) {
    return addAttachments(engagement, engagementRecord.attachments);
  }).then(logAtMentions).then(addEngagementToTimeline);
}

function processEngagement(engagementRecord) {
  return performEngagementProcessing(engagementRecord);
}

function updateOwnerAssociations(engagementRecord, engagementId) {
  var hasAssociations = engagementRecord.associations;
  var associations = engagementRecord.associations.get('ownerIds');

  if (hasAssociations && associations && associations.size > 0) {
    var associationUpdates = (0, _ownerUpdates.default)((0, _immutable.List)(associations), (0, _immutable.List)());
    EngagementsActions.updateAssociations(engagementId, associationUpdates);
  }
}

function updateAssociations(engagementRecord, engagementId, initialCallAssociations) {
  var engagementAssociations = engagementRecord.get('associations');
  (0, _UpdateAssociationsHelper.updateEngagementAssociations)(engagementId, initialCallAssociations, engagementAssociations);
}

function updateEngagementFieldsAndAssociations(engagementId, engagementRecord, updates, initialCallAssociations) {
  updateOwnerAssociations(engagementRecord, engagementId);
  updateAssociations(engagementRecord, engagementId, initialCallAssociations);
  return EngagementsActions.updateEngagement(engagementId, (0, _immutable.fromJS)(updates)).then(function (updatedEngagement) {
    var engagementTimestamp = updatedEngagement.getIn(['engagement', 'timestamp']);
    return processEngagement(engagementRecord.setIn(['engagement', 'timestamp'], engagementTimestamp));
  });
}